<template>
  <RegistrationForm />
</template>

<script>
import RegistrationForm from '@/components/auth/RegistrationForm.vue';

export default {
  name: "RegistrationPage",
  components: {
    RegistrationForm,
  },
};
</script>

<style scoped>
/* Add any necessary styling here */
</style>